import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FilesAnalysis from './components/FilesAnalysis';

const filesAnalysis = (props,{ t }) => (
  <Container>
    <FilesAnalysis {...props} />
  </Container>
);

filesAnalysis.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(filesAnalysis);
